@if (feature !== 'noStatus') {
  <div id="badge" [class]="[status, feature]">
    <div>
      @if (status === 'warning') {
        <i class="fa-solid fa-triangle-exclamation" [ngClass]="status"></i>
      }
      {{ feature | rewriteFeature | translate | uppercase }}
    </div>
  </div>
}
